import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalizeRomanNumerals',
})
export class CapitalizeRomanNumeralsPipe implements PipeTransform {
  transform(value: string): string {
    // Split the value into first name and last name
    const nameParts = value.split(' ');
    const firstName = nameParts.slice(0, -1).join(' ');
    const lastName = nameParts[nameParts.length - 1];

    // Capitalize the last name
    const capitalizedLastName = this.capitalizeWithRomanNumerals(lastName);

    // Return the formatted name
    return `${firstName} ${capitalizedLastName}`;
  }

  capitalizeWithRomanNumerals(value: string): string {
    const words = value.split(' ');

    for (let i = 0; i < words.length; i++) {
      const word = words[i];

      if (this.isRomanNumeral(word)) {
        words[i] = word.toUpperCase();
      }
    }

    return words.join(' ');
  }

  isRomanNumeral(value: string): boolean {
    const romanNumerals = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];
    return romanNumerals.includes(value.toUpperCase());
  }
}
